import React from 'react'
import { GENDER_LIST_ONBOARDING } from 'src/consumer/constants'
import { getAgeFromDobWithTime } from 'src/consumer/helpers/profilePageHelper'
import {
  PMPHeaderDetails,
  PMPHeadingBanner,
} from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'
import dayjs from 'dayjs'
import {
  getDateOfAssessmentReport,
  parseReportTimestamp,
} from 'src/mentor/components/TherapyReportMakingPage/TherapyReportMakingPageComponents'

export default function AssessmentReportHeader({
  reportData,
  therapistName,
  templateData,
  therapyDate,
}) {
  // if (!therapyReportData?.createdTime) {
  // }

  return (
    <div style={{ background: '#FFF' }}>
      <PMPHeadingBanner noColor={true}>
        {templateData?.headingText || 'Therapy Report'}
      </PMPHeadingBanner>
      <PMPHeaderDetails className="d-flex justify-content-between" noColor={true}>
        <div>
          <div>
            Patient Name:{' '}
            <span style={{ textTransform: 'capitalize' }}>
              {reportData?.patientName} ({reportData?.patientNumber})
            </span>
          </div>
          <div>
            Age/Gender: {getAgeFromDobWithTime(reportData?.patientDateOfBirth)}/
            {
              GENDER_LIST_ONBOARDING?.find((item) => item.value === reportData?.patientGender)
                ?.label
            }
          </div>
        </div>
        <div>
          <div>
            Date :{' '}
            {therapyDate
              ? (() => {
                  const d = parseReportTimestamp(therapyDate)
                  return d?.isValid() ? d.local().format('DD/MM/YYYY') : '—'
                })()
              : getDateOfAssessmentReport(reportData, null) ?? '—'}
          </div>
          {therapistName && (
            <div>
              <b>Therapist : {therapistName}</b>
            </div>
          )}
          {/* <div>
              <span>
                <b>Screening consulted for : </b>
                {therapyReportData?.requestingDoctorName || 'NA'}
              </span>
            </div> */}
        </div>
      </PMPHeaderDetails>
    </div>
  )
}
